import { apiCrm, apiChatTS } from '../../../http';
// import { mockCheckConversationAssociations } from './associationService.mock';

// CONFIGURAÇÃO DE DESENVOLVIMENTO
// Altere para true para usar dados mockados durante desenvolvimento
const USE_MOCK_DATA = false;

class AssociationService {
  /**
   * Associa leads e oportunidades a uma conversa
   * @param {Object} data - Dados da associação
   * @param {string} data.conversationId - ID da conversa
   * @param {string} data.conversationInAttendanceId - ID da conversa em atendimento
   * @param {string} data.channel - Canal da conversa
   * @param {string} data.attendantName - Nome do atendente
   * @param {string} data.attendantLogin - Login do atendente
   * @param {string} data.clientName - Nome do cliente
   * @param {string} data.clientPhone - Telefone do cliente
   * @param {Array} data.leadIds - Array de IDs dos leads
   * @param {Array} data.opportunityIds - Array de IDs das oportunidades
   * @param {string} data.leadsRecordTypeId - ID do record type dos leads
   * @param {string} data.opportunitiesRecordTypeId - ID do record type das oportunidades
   * @returns {Promise} Resposta da API
   */
  async associateLeadOpportunity(data) {
    // Usar a URL do chat-ts em vez da API CRM
    return apiChatTS.post('/associate-lead-oportunidade', data);
  }

  /**
   * Associa apenas leads a uma conversa (método legado)
   * @param {Object} data - Dados da associação de leads
   * @returns {Promise} Resposta da API
   */
  async associateLead(data) {
    return apiCrm.post('associateLead', data);
  }

  /**
   * Associa apenas oportunidades a uma conversa (método legado)
   * @param {Object} data - Dados da associação de oportunidades
   * @returns {Promise} Resposta da API
   */
  async associateOpportunity(data) {
    return apiCrm.post('associateOpportunity', data);
  }

  /**
   * Verifica associações existentes de uma conversa
   * @param {string} conversationInAttendanceId - ID da conversa em atendimento
   * @param {Array} leadIds - Array de IDs dos leads (opcional)
   * @param {Array} opportunityIds - Array de IDs das oportunidades (opcional)
   * @returns {Promise} Resposta da API
   */
  async checkConversationAssociations(
    conversationInAttendanceId,
    leadIds = [],
    opportunityIds = []
  ) {
    const params = {};

    if (leadIds && leadIds.length > 0) {
      params.leadIds = leadIds.join(',');
    }

    if (opportunityIds && opportunityIds.length > 0) {
      params.opportunityIds = opportunityIds.join(',');
    }

    const response = await apiChatTS.get(
      `/conversation-associations/${conversationInAttendanceId}`,
      { params }
    );

    return response.data;
  }

  /**
   * Obtém associações de uma conversa
   * @param {string} conversationId - ID da conversa
   * @returns {Promise} Resposta da API
   */
  async getAssociations(conversationId) {
    return apiCrm.get(`associations/${conversationId}`);
  }

  /**
   * Remove associação de lead de uma conversa
   * @param {string} associationId - ID da associação
   * @returns {Promise} Resposta da API
   */
  async removeLeadAssociation(associationId) {
    return apiCrm.delete(`association/lead/${associationId}`);
  }

  /**
   * Remove associação de oportunidade de uma conversa
   * @param {string} associationId - ID da associação
   * @returns {Promise} Resposta da API
   */
  async removeOpportunityAssociation(associationId) {
    return apiCrm.delete(`association/opportunity/${associationId}`);
  }
}

export default new AssociationService();
